module.exports = __webpack_public_path__ + "img/govt-tag.0ae74000.svg";